const templateManagementAddOrEditTemplateRoleListTableItems = [
    { title: "Role Name", key: "RoleName", order: 1, isCheckBox: false, isDate: false, width: "unset", maxWidth: "200px", fw: "500" },
    { title: "Description", key: "Description", order: 2, isCheckBox: false, isDate: false, width: "unset", maxWidth: "250px", fw: "unset" },
    { title: "Protected", key: "IsProtected", order: 3, isCheckBox: true, isDate: false, width: "unset", maxWidth: "150px", fw: "unset" },
    { title: "Permissions", key: "", order: 4, isCheckBox: false, isDate: false, width: "130px", maxWidth: "unset", fw: "unset" }
]

export default templateManagementAddOrEditTemplateRoleListTableItems